/**
 *
 * CheckboxUpsellModal copied from ConfirmationDialog
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { useMediaQuery } from '@mui/material';
import { PricingTable } from '../../pages/UpgradePage/pricingTable';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

export interface CheckboxUpsellModalProps {
  id?: string; 
  keepMounted?: boolean;
  open: boolean;
  onClose: (value?: string) => void;
  onCancel?: (value?: string) => void;
  onConfirm: () => void;
  confirmButtonText: string,
  title?: string,
  description?: string
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(min(100dvw, 800px))',
  maxHeight: '100dvh',
  overflowY: 'scroll',
  bgcolor: 'background.paper',
  border: '1px solid #FF74E9',
  boxShadow: 24,
};



export function CheckboxUpsellModal(props: CheckboxUpsellModalProps) {
  const { onClose, onConfirm, open, confirmButtonText, title, description, ...other } = props;
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onConfirm();
  };


  return (
    <Modal
        open={open}
        onClose={handleCancel}
        disableAutoFocus={true}
    >
      <Box sx={{
        ...style, 
        p: isMobile ? 2 : 4, 
        borderRadius: isMobile ? "0px" : '20px', 
      }}>
        <ModalContent>
          <ModalHeader>
            <h2>
              {title}
            </h2>
            <FontAwesomeIcon icon={faTimes} onClick={handleCancel} size={"xs"} />
          </ModalHeader>
          
          {description && <DescriptionStyle>{description}</DescriptionStyle>}

          <PricingTable small={true} isCheckboxSelectMode={true} hideFreePlan={true} hideContractCard={true} />
          {confirmButtonText && (
            <Button variant="text" onClick={handleOk}>{confirmButtonText}</Button>
          )}
          <br/>

        </ModalContent>
      </Box>
    </Modal>

  );
}

const TitleStyle = styled.span`
  font-size: 0.6em;
  font-weight: 600;
  font-family: 'Raleway';
  font-weight: 700;

  @media (max-width: 600px) {
    font-size: 0.5em;
  }
`;

const DescriptionStyle = styled.span`
  font-size: 20px;
  font-family: 'Raleway';

  @media (max-width: 600px) {
    font-size: 16px;
    text-align: center;
  }
`;


const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  min-height: 400px;
  @media only screen and (max-width: 600px) {
    //padding-right: 16px;
    //padding-left: 16px;
    //padding-bottom: 16px;
  }
`;

const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
